var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoShare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.30494 7.74753C5.84525 6.82992 4.89619 6.2 3.8 6.2C2.2536 6.2 1 7.4536 1 9C1 10.5464 2.2536 11.8 3.8 11.8C4.89619 11.8 5.84525 11.1701 6.30494 10.2525M6.30494 7.74753C6.49374 8.1244 6.6 8.54979 6.6 9C6.6 9.45021 6.49374 9.8756 6.30494 10.2525M6.30494 7.74753L11.6951 5.05247M6.30494 10.2525L11.6951 12.9475M11.6951 5.05247C12.1548 5.97008 13.1038 6.6 14.2 6.6C15.7464 6.6 17 5.3464 17 3.8C17 2.2536 15.7464 1 14.2 1C12.6536 1 11.4 2.2536 11.4 3.8C11.4 4.25021 11.5063 4.6756 11.6951 5.05247ZM11.6951 12.9475C11.5063 13.3244 11.4 13.7498 11.4 14.2C11.4 15.7464 12.6536 17 14.2 17C15.7464 17 17 15.7464 17 14.2C17 12.6536 15.7464 11.4 14.2 11.4C13.1038 11.4 12.1548 12.0299 11.6951 12.9475Z",
    stroke: "#0C002C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoShare);
export default __webpack_public_path__ + "static/media/ico_share.2aa61b19d1282eeaeda03adde1ad196b.svg";
export { ForwardRef as ReactComponent };